import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { KPICard } from '../../components/ui/KPICard';
import { DataTable } from '../../components/ui/DataTable';
import { StatusPill } from '../../components/ui/StatusPill';
import { Button } from '../../components/ui/Button';
import { Timeline } from '../../components/ui/Timeline';
import { TruckIcon, PackageIcon, AlertCircleIcon, ArrowLeftIcon } from 'lucide-react';
const shipments = [{
  id: 'ASN-2026-0451',
  poRef: 'PO-2026-00140',
  carrier: 'SwiftHaul Logistics',
  eta: '2026-03-20',
  status: 'In Transit'
}, {
  id: 'ASN-2026-0450',
  poRef: 'PO-2026-00135',
  carrier: 'FedEx Freight',
  eta: '2026-03-17',
  status: 'In Transit'
}, {
  id: 'ASN-2026-0448',
  poRef: 'PO-2026-00132',
  carrier: 'Internal Fleet',
  eta: '2026-03-08',
  status: 'Delivered'
}];
export const ShipmentsPage: React.FC = () => {
  const [selectedShipment, setSelectedShipment] = useState<any>(null);
  if (selectedShipment) {
    return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1711">
        <Button variant="ghost" leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-1713" />} onClick={() => setSelectedShipment(null)} className="-ml-4" data-id="element-1712">
          Back to Shipments
        </Button>
        <PageHeader title={`Shipment ${selectedShipment.id}`} description={`PO Reference: ${selectedShipment.poRef}`} primaryAction={<Button variant="secondary" data-id="element-1715">Download Packing Slip</Button>} data-id="element-1714" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1716">
          <div className="lg:col-span-2 space-y-6" data-id="element-1717">
            <Card data-id="element-1718">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1719">
                Shipment Details
              </h2>
              <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-1720">
                <div data-id="element-1721">
                  <span className="text-text-secondary block" data-id="element-1722">Carrier</span>
                  <span className="font-medium" data-id="element-1723">
                    {selectedShipment.carrier}
                  </span>
                </div>
                <div data-id="element-1724">
                  <span className="text-text-secondary block" data-id="element-1725">
                    Tracking Number
                  </span>
                  <span className="font-medium text-fpg-navy cursor-pointer" data-id="element-1726">
                    TRK-99887766
                  </span>
                </div>
                <div data-id="element-1727">
                  <span className="text-text-secondary block" data-id="element-1728">
                    Estimated Arrival
                  </span>
                  <span className="font-medium" data-id="element-1729">{selectedShipment.eta}</span>
                </div>
                <div data-id="element-1730">
                  <span className="text-text-secondary block" data-id="element-1731">
                    Total Weight
                  </span>
                  <span className="font-medium" data-id="element-1732">1,250 KG</span>
                </div>
              </div>
            </Card>
            <Card data-id="element-1733">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1734">
                Packed Items
              </h2>
              <DataTable data={[{
              line: 1,
              item: 'Fresh Tiger Prawns',
              qty: '200 KG',
              packed: '200 KG'
            }, {
              line: 2,
              item: 'Norwegian Salmon',
              qty: '150 PKT',
              packed: '150 PKT'
            }]} columns={[{
              header: 'Line',
              accessorKey: 'line'
            }, {
              header: 'Item',
              accessorKey: 'item'
            }, {
              header: 'Ordered Qty',
              accessorKey: 'qty'
            }, {
              header: 'Packed Qty',
              accessorKey: 'packed'
            }]} data-id="element-1735" />
            </Card>
          </div>
          <div className="space-y-6" data-id="element-1736">
            <Card data-id="element-1737">
              <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-1738">
                Tracking Timeline
              </h2>
              <Timeline items={[{
              id: '1',
              title: 'ASN Created',
              timestamp: 'Mar 15, 2026 09:00',
              status: 'success'
            }, {
              id: '2',
              title: 'Picked Up by Carrier',
              timestamp: 'Mar 15, 2026 14:30',
              status: 'success'
            }, {
              id: '3',
              title: 'In Transit',
              description: 'Departed origin facility',
              timestamp: 'Mar 16, 2026 08:15',
              status: 'info'
            }, {
              id: '4',
              title: 'Out for Delivery',
              timestamp: 'Pending',
              status: 'default'
            }, {
              id: '5',
              title: 'Delivered',
              timestamp: 'Pending',
              status: 'default'
            }]} data-id="element-1739" />
            </Card>
          </div>
        </div>
      </div>;
  }
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-1740">
      <PageHeader title="Shipments & ASNs" description="Create advance shipping notices and track deliveries." breadcrumbs={[{
      label: 'Home',
      href: '/supplier/dashboard'
    }, {
      label: 'Shipments'
    }]} primaryAction={<Button variant="primary" leftIcon={<TruckIcon className="w-4 h-4" data-id="element-1743" />} data-id="element-1742">
            Create ASN
          </Button>} data-id="element-1741" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1744">
        <KPICard title="In Transit" value="2" icon={<TruckIcon className="w-5 h-5 text-status-info" data-id="element-1746" />} data-id="element-1745" />
        <KPICard title="Delivered (Last 30 Days)" value="1" icon={<PackageIcon className="w-5 h-5 text-status-success" data-id="element-1748" />} data-id="element-1747" />
        <KPICard title="Exceptions" value="0" icon={<AlertCircleIcon className="w-5 h-5 text-text-tertiary" data-id="element-1750" />} data-id="element-1749" />
      </div>

      <Card data-id="element-1751">
        <div className="mb-4 flex justify-between items-center" data-id="element-1752">
          <h2 className="text-lg font-semibold text-text-primary" data-id="element-1753">
            Recent Shipments
          </h2>
        </div>
        <DataTable data={shipments} columns={[{
        header: 'ASN Number',
        accessorKey: 'id',
        cell: row => <span className="font-medium text-fpg-navy" data-id="element-1755">{row.id}</span>
      }, {
        header: 'PO Reference',
        accessorKey: 'poRef'
      }, {
        header: 'Carrier',
        accessorKey: 'carrier'
      }, {
        header: 'ETA',
        accessorKey: 'eta'
      }, {
        header: 'Status',
        cell: row => <StatusPill status={row.status} data-id="element-1756" />
      }]} onRowClick={setSelectedShipment} data-id="element-1754" />
      </Card>
    </div>;
};